import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgSlidersHorizontal = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M4.375 9.625h3.61a3.5 3.5 0 0 0 6.78 0h8.86a.875.875 0 1 0 0-1.75h-8.86a3.5 3.5 0 0 0-6.78 0h-3.61a.875.875 0 1 0 0 1.75Zm7-2.625a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5Zm12.25 11.375h-1.86a3.5 3.5 0 0 0-6.78 0H4.374a.875.875 0 0 0 0 1.75h10.61a3.5 3.5 0 0 0 6.78 0h1.86a.875.875 0 1 0 0-1.75ZM18.375 21a1.75 1.75 0 1 1 0-3.5 1.75 1.75 0 0 1 0 3.5Z" />
  </svg>
);
export default SvgSlidersHorizontal;
